"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/// <reference types="jquery"/>
exports.default = {
    props: ['name', 'action', 'label', 'cssIcon', 'cssButton'],
    data: function () {
        var rows = [], model = this.$root._data, nameCount = this.name + 'Count', childCount = model.data != null ? +model.data[nameCount] || 0 : 0;
        if (childCount == 0) {
            this.addRow(rows);
        }
        else {
            for (var i = 0; i < childCount; i++) {
                this.populateRows(rows, i);
            }
        }
        return {
            rows: rows,
            childCount: childCount,
            nameCount: nameCount,
            isReadOnly: model.readOnly,
        };
    },
    methods: {
        getBtnCss: function () {
            return "btn " + (this.cssButton || "btn-primary") + " mt-2 float-right";
        },
        getIconCss: function () {
            return "" + (this.cssIcon || "fa fa-plus");
        },
        addRow: function (rows) {
            var _this = this;
            this.populateRows(rows);
            this.rows = rows;
            this.childCount = this.rows.length;
            var lastRow = this.rows[this.rows.length - 1];
            var $inputs = $(this.$el).find("div[name^=childInput]").find("input, textarea");
            if ($inputs.length === 0 || $inputs.length === $inputs.filter(function (i, el) {
                var $el = $(el);
                return $el.val();
            }).length) {
                setTimeout(function () {
                    $($(_this.$el).find("div[name=\"" + lastRow.name + "\"]").find("input, textarea")[0]).focus();
                }, 300);
            }
        },
        removeRow: function (row) {
            var index = this.rows.indexOf(row, 0);
            if (index > -1) {
                this.rows.splice(index, 1);
            }
            this.childCount = this.rows.length;
            this.updateInput();
        },
        populateRows: function (rows, index) {
            if (!index) {
                index = rows.length;
            }
            rows.push({
                name: 'childInput' + (index + 1),
                class: index > 0 ? "overflow-auto" : "",
                isOk: false,
                index: index
            });
        },
        updateInput: function () {
            var _this = this;
            var i = 0;
            this.rows.map(function (r) {
                var $d = $(_this.$el).find("div[name=\"" + r.name + "\"]");
                if (r.index != i) {
                    r.name = 'childInput' + (i + 1);
                    r.index = i;
                    $d.attr("name", r.name);
                }
                $d.find("input, textarea").map(function (ii, el) {
                    if (el.name) {
                        var $el = $(el);
                        if (!$el.data("name")) {
                            $el.data("name", el.name);
                        }
                        var template = _this.name + "." + i + ".";
                        var name = "" + template + $el.data("name");
                        el.name = name;
                    }
                });
                i = i + 1;
            });
        }
    },
    updated: function () {
        this.updateInput();
    },
    mounted: function () {
        var _this = this;
        var model = this.$root._data, children = model.data != null ? model.data[this.name] || [] : [];
        this.updateInput();
        // Si on a pas d'enfants alors ça ne sert à rien de continuer
        if (children.length <= 0) {
            return;
        }
        children.forEach(function (c, i) {
            var row = _this.rows[i];
            for (var _i = 0, _a = Object.keys(c); _i < _a.length; _i++) {
                var inputName = _a[_i];
                // On récupère le tag correspondant au nom précédent
                var key = _this.name + "." + i + "." + inputName;
                var inputTag = $(_this.$el).find("[name=\"" + key + "\"]");
                model[key] = c[inputName];
                // On set la value de ce tag
                if (c[inputName]) {
                    inputTag.val(c[inputName]);
                }
                else {
                    inputTag.val(null);
                }
            }
        });
    }
};



//////////////////
// WEBPACK FOOTER
// ./node_modules/ts-loader!./node_modules/vue-loader/lib/selector.js?type=script&index=0&bustCache!./_wwwsrc/js/Workflow/Components/Input/MultipleInput.vue
// module id = 201
// module chunks = 0